<template>
  <v-btn
    v-if="isMobile"
    icon="menu"
    variant="text"
    size="small"
    class="app-navbar__menu"
    aria-label="Open navigation menu"
    @click="emit('toggle-drawer')"
  />

  <RouterLink
    class="app-navbar__logo"
    :class="{ 'app-navbar__logo--compact': isMobile }"
    to="/"
    aria-label="Visit home page"
  >
    <VuesticLogo :compact="isMobile" :height="28" />
  </RouterLink>

  <v-spacer class="app-navbar__spacer" />

  <AppNavbarActions class="app-navbar__actions" :is-mobile="isMobile" />
</template>

<script setup lang="ts">
import AppNavbarActions from './components/AppNavbarActions.vue'
import VuesticLogo from '../VuesticLogo.vue'

defineProps({
  isMobile: { type: Boolean, default: false },
})

const emit = defineEmits<{
  (e: 'toggle-drawer'): void
}>()
</script>

<style lang="scss" scoped>
.app-navbar__menu {
  flex-shrink: 0;
  margin-inline-end: 0.15rem;
}

.app-navbar__logo {
  display: flex;
  align-items: center;
  flex-shrink: 0;
  margin-right: 0.5rem;

  &--compact {
    margin-right: 0.25rem;
  }
}

.app-navbar__spacer {
  flex-grow: 1;
  flex-shrink: 1;
  min-width: 0.25rem;
}

.app-navbar__actions {
  flex-shrink: 0;
  min-width: 0;
}
</style>
